/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export default function createUIManager(state) {
  const canvas = document.getElementById('sprayCanvas');
  const scaleRange = document.getElementById('scaleRange');      
  const radiusRange = document.getElementById('radiusRange');    
  const densityRange = document.getElementById('densityRange');  
  const speedFactorInput = document.getElementById('speedFactor');
  const scaleVal = document.getElementById('scaleVal');          
  const radiusVal = document.getElementById('radiusVal');        
  const densityVal = document.getElementById('densityVal');      
  const speedFactorVal = document.getElementById('speedFactorVal');
  const customCursor = document.getElementById('customCursor');
  function updatePaintUI(canId, oldPaint, newPaint) {
    const percentage = Math.round((newPaint / state.config.paintMax) * 100);
    const canFill = document.getElementById('can-fill-' + canId);
    const canPercentage = document.querySelector('.can-item[data-can-id="' + canId + '"] .can-percentage');
    if (canFill && canPercentage) {
      canFill.style.height = percentage + '%';
      canPercentage.textContent = percentage + '%';
      if (newPaint < oldPaint) {
        canFill.classList.remove('paint-decrease-animation');
        void canFill.offsetWidth;
        canFill.classList.add('paint-decrease-animation');
        setTimeout(() => canFill.classList.remove('paint-decrease-animation'), 300);
      }
    }
    if (typeof window.onMobilePaintUpdate === 'function') {
      window.onMobilePaintUpdate(canId, newPaint);
    }
    state.cansData.forEach(canItem => {
      if (canItem.paintLeft === undefined) {
        canItem.paintLeft = state.config.paintMax;
      }
      const canItemPercentage = Math.round((canItem.paintLeft / state.config.paintMax) * 100);
      const canElement = document.querySelector('.can-item[data-can-id="' + canItem.id + '"] .can-percentage');
      if (canElement) {
        canElement.textContent = canItemPercentage + '%';
      }
      const canItemFill = document.getElementById('can-fill-' + canItem.id);
      if (canItemFill) {
        canItemFill.style.height = canItemPercentage + '%';
      }
    });
  }
  function updateUI() {
    if (scaleVal) {
      scaleVal.textContent = state.config.lineScale.toFixed(2);
    }
    if (radiusVal) {
      radiusVal.textContent = Math.round(state.config.sprayRadius);
    }
    if (densityVal) {
      densityVal.textContent = Math.round(state.config.dotsPerTick);
    }
    if (speedFactorVal) {
      speedFactorVal.textContent = state.config.speedFactor.toFixed(1);
    }
  }
  function updateCursor(e) {
    if (!customCursor) return;
    const x = e.clientX || ((e.touches && e.touches[0] && e.touches[0].clientX) || 0);
    const y = e.clientY || ((e.touches && e.touches[0] && e.touches[0].clientY) || 0);
    customCursor.style.left = x + 'px';
    customCursor.style.top = y + 'px';
    customCursor.style.display = 'block';
    customCursor.style.background = state.config.currentColor;
    customCursor.style.boxShadow = '0 0 6px ' + state.config.currentColor + 'A0';
  }
  state.onPaintUpdate = updatePaintUI;
  state.onUIUpdate = updateUI;
  return {
    updateUI,        
    updatePaintUI,   
    updateCursor     
  };
}
